import {
  useEffect, useState,
} from 'react';
import type { ModalProps } from '~/modal/modalType.enum';
import { useDataLayersToolActiveBTGsSelector } from '~/store/boundaryTerritoryGroups/dataLayersTool/dataLayersBTGs.selectors';
import { isBTGForDataLayer } from '~/store/boundaryTerritoryGroups/dataLayersTool/dataLayersToolBTGs.helpers';
import type { DataLayerGroupId } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';
import { useDataLayersEditViaBTG } from '../useDataLayersEditViaBTG';
import { DataLayerFillEditModalComponent } from './dataLayerFillEditModal.component';

export type DataLayerFillEditModalProps = ModalProps<{
  dataLayerGroupId: DataLayerGroupId;
}>;

export const DataLayerFillEditModalContainer = ({
  dataLayerGroupId,
  ...modalProps
}: DataLayerFillEditModalProps) => {
  const activeBoundaryTerritoryGroups = useDataLayersToolActiveBTGsSelector();
  const [demographic] = useState(activeBoundaryTerritoryGroups.find(
    btg => isBTGForDataLayer(dataLayerGroupId, btg),
  )?.settings.demographicId ?? null);

  const {
    dataLayerGroup,
    boundaryTerritoryGroup,
    individualSettingsActive,
    rangeMin,
    rangeMax,
    updateBoundaryTerritoryGroup,
    onIndividualSettingsActiveChange,
    onNumberOfRangesChange,
    onBoundaryTerritoryChange,
    onRecalculateRangesClick,
    onRestoreDefaultColors,
    isLoading,
    onSubmit,
  } = useDataLayersEditViaBTG(dataLayerGroupId, demographic);

  const onSubmitClick = () => {
    onSubmit({ onDone: () => modalProps.onClose() });
  };

  useEffect(() => {
    if (!dataLayerGroup) {
      modalProps.onClose();
    }
  }, [dataLayerGroup, modalProps]);

  if (!dataLayerGroup || !boundaryTerritoryGroup) {
    return null;
  }

  return (
    <DataLayerFillEditModalComponent
      boundaryTerritoryGroup={boundaryTerritoryGroup}
      individualSettingsActive={individualSettingsActive}
      isSubmitDisabled={isLoading}
      isLoading={isLoading}
      rangeMin={rangeMin}
      rangeMax={rangeMax}
      onBoundaryTerritoryGroupChange={updateBoundaryTerritoryGroup}
      onBoundaryTerritoryChange={onBoundaryTerritoryChange}
      onIndividualSettingsActiveChange={onIndividualSettingsActiveChange}
      onNumberOfRangesChange={onNumberOfRangesChange}
      onRecalculateRangesClick={onRecalculateRangesClick}
      onRestoreDefaultColors={onRestoreDefaultColors}
      onSubmitClick={onSubmitClick}
      {...modalProps}
    />
  );
};
